// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".jut__CustomStateWrapper__customStateContainer__u8ZImY{grid-column:1/span var(--column-length)}", "",{"version":3,"sources":["webpack://./../../platform/@jutro/components/components/DataTable/components/CustomStateWrapper/CustomStateWrapper.module.css"],"names":[],"mappings":"AAAA,uDACE,uCAAA","sourcesContent":[".customStateContainer {\n  grid-column: 1/span var(--column-length);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"customStateContainer": "jut__CustomStateWrapper__customStateContainer__u8ZImY"
};
export default ___CSS_LOADER_EXPORT___;
